/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Loading from "./Loader";
import { Button } from "./Button";
import { Link } from "react-router-dom";
import fb from '../images/cat/fb.png';
import linked from '../images/cat/in.png';
import google from '../images/cat/google.png';
import * as constants from "../constants";
import UserService from "../services/UserService";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import  SociaLoginSignUp from './auth/SocialLoginSignUp'
import  SocialLoginSignUp  from "./auth/SocialLoginSignUp";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import { setCurrentComponent, setType, setUser, setSignUpUser } from "../actions";
import NotificationMessage from "./Toast/NotificationMessage";
import moment from 'moment';
import Select from 'react-select';
import Payment from './Payment';
export class SignUp extends Component {
    constructor(props) {
        super(props);
        this[constants.SIGNUP_REFS.STUDENT_REF] = React.createRef();
        this[constants.SIGNUP_REFS.PARENT_REF] = React.createRef();
        this.state = {
          userName: this.props?.signUpUser?.userName,
          email: this.props?.signUpUser?.email,
          studentEmail: this.props?.signUpUser?.studentEmail,
          studentName: this.props?.signUpUser?.studentName,
          studentMobile: this.props?.signUpUser?.studentMobile,
          userEmail: this.props?.signUpUser?.userEmail,
          studentNameForParentSignUp: this.props?.signUpUser?.studentNameForParentSignUp,
          mobileNo: this.props?.signUpUser?.mobileNo,
          errors: {},
          centers: this.props?.signUpUser?.centers,
          batches: this.props?.signUpUser?.batches,
          selectedCenter: this.props?.signUpUser?.selectedCenter,
          selectedBatch: this.props?.signUpUser?.selectedBatch,
          userCode: null,
          studentCode: null,
          role_id: this.props?.signUpUser?.role_id || constants.ROLE_ID.STUDENT,
          parentCode: null, 
          isLoading: false,
          showModuleDialog: true,
          selectedModule: null,
          targetYear: null,
          targetExam: 'JEE',
          filterType: null,
          disable2028: false,
          showPayment: false,
          signupComplete: false,
          availableYears: [],
          selectedBatchId: null
        };
    }
    componentDidMount = () => {
        this.props.renderImage(constants.SHOWIMAGE.STUDENTSIGNUPIMAGE);
        this.props.setType(constants.TYPE.SIGNUP)
        this.props.setSignUpType(constants.SHOWCOMPONENT.STUDENTSIGNUP);
        
        let signUpFormData = this.getFormData();
        if(Object.keys(signUpFormData).length !== 0){
            const now = moment();
            const check = moment(signUpFormData.timeout);
            let difference = moment.duration(now.diff(check));
            difference = difference.asMinutes();
            if(difference > 60 ){
                sessionStorage.removeItem('signUpFormData');
            }
        }
        
        this.setStateValues();
        
        // Check if module is pre-selected from Purchase Now button (after setStateValues)
        const selectedModuleData = sessionStorage.getItem('selectedModule');
        console.log('Selected module data from session:', selectedModuleData);
        if(selectedModuleData) {
            const moduleInfo = JSON.parse(selectedModuleData);
            // Set the pre-selected module and filtering parameters
            this.setState({
                selectedModule: moduleInfo.autoSelectModule || moduleInfo.selectedModule,
                filterType: moduleInfo.filterType,
                targetYear: moduleInfo.presetYear || null,
                targetExam: moduleInfo.presetExam || 'JEE',
                disable2028: moduleInfo.disable2028 || false
            });
            
            // If exam is pre-selected, call API to get available years
            if(moduleInfo.presetExam) {
                this.getBatchesByExam(moduleInfo.presetExam, moduleInfo.presetYear);
            }
        } else {
            // If no module data, user came from "Don't Have An Account? Signup" - clear filters but preserve targetExam
            const signUpFormData = this.getFormData();
            const restoredExam = signUpFormData.targetExam || 'JEE';
            this.setState({
                filterType: null,
                targetYear: null,
                targetExam: restoredExam
            }, () => {
                // Fetch available years for the restored/default exam
                this.getBatchesByExam(restoredExam);
            });
        }
        if(this.props && this.props.signUpRef){
            this[this.props.signUpRef]?.current?.focus();
        }
    }
    getFormData = () => {
        let signUpFormData = sessionStorage.getItem('signUpFormData') ? JSON.parse(sessionStorage.getItem('signUpFormData')) : {};
        return signUpFormData;
    }
    setStateValues = () => {
        let signUpFormData = this.getFormData();
        if(signUpFormData){
            if(signUpFormData.selectedCenter){
            this.getBatches(signUpFormData.selectedCenter);
            }
            this.setState({
                userName: signUpFormData.userName || "",
                studentName: signUpFormData.studentName || "",
                email: signUpFormData.email || "",
                studentEmail: signUpFormData.studentEmail || "",
                mobileNo: signUpFormData.mobileNo || "",
                studentMobile: signUpFormData.studentMobile || "",
                selectedCenter: signUpFormData.selectedCenter || null,
                selectedBatch: signUpFormData.selectedBatch || null,
                role_id: signUpFormData.role_id || constants.ROLE_ID.STUDENT,
                selectedModule: signUpFormData.selectedModule || null,
                targetYear: signUpFormData.targetYear || null,
                targetExam: signUpFormData.targetExam || 'JEE'
            });
            this.setImage(signUpFormData.role_id);
            if((signUpFormData.role_id == constants.ROLE_ID.PARENT) && signUpFormData.studentEmail){
                this.getStudentByEmail(signUpFormData.studentEmail);
            }
        }
    }
    setSignUpFormData = (fieldName, fieldValue) =>{
        let signUpFormData = this.getFormData();
        signUpFormData[fieldName] = fieldValue;
        signUpFormData["timeout"] = moment();
        sessionStorage.setItem('signUpFormData', JSON.stringify(signUpFormData));
    }
    
    handleModuleSelect = (moduleId) => {
        console.log('Module selected:', moduleId);
        this.setState({ selectedModule: moduleId });
        this.setSignUpFormData("selectedModule", moduleId);
        
        // Store in sessionStorage in the same format as PricingTab components
        const moduleData = {
            selectedModule: moduleId,
            timestamp: new Date().getTime()
        };
        sessionStorage.setItem('selectedModule', JSON.stringify(moduleData));
    }
    
    handleTargetYearSelect = (year) => {
        const selectedYearData = this.state.availableYears.find(y => y.year === year);
        
        // Clear the old selected module when year changes
        this.setState({ 
            targetYear: year, 
            selectedModule: null,
            selectedBatchId: selectedYearData ? selectedYearData.id : null
        });
        this.setSignUpFormData("targetYear", year);
    }
    
    handleTargetExamSelect = (exam) => {
        // Update filterType based on current filterType and new exam selection
        let newFilterType = this.state.filterType;
        if (this.state.filterType === 'AITS_NEET_ONLY' && exam === 'JEE') {
            newFilterType = 'AITS_JEE_ONLY';
        } else if (this.state.filterType === 'AITS_JEE_ONLY' && exam === 'NEET') {
            newFilterType = 'AITS_NEET_ONLY';
        }
        
        // Clear autoSelectModule from sessionStorage when user manually changes exam
        // const selectedModuleData = sessionStorage.getItem('selectedModule');
        // if (selectedModuleData) {
        //     const moduleInfo = JSON.parse(selectedModuleData);
        //     if (moduleInfo.autoSelectModule) {
        //         delete moduleInfo.autoSelectModule;
        //         sessionStorage.setItem('selectedModule', JSON.stringify(moduleInfo));
        //     }
        // }
        
        this.setState({ 
            targetExam: exam, 
            selectedModule: null, 
            targetYear: null, 
            availableYears: [], 
            selectedBatchId: null,
            filterType: newFilterType
        }, () => {
            this.getBatchesByExam(exam);
        });
        this.setSignUpFormData("targetExam", exam);
    }
    
    autoSelectModuleBasedOnFilter = () => {
        if (!this.state.targetYear || !this.state.targetExam) return;
        
        let moduleToSelect = null;
        
        // First check if there's a specific autoSelectModule from sessionStorage
        const selectedModuleData = sessionStorage.getItem('selectedModule');
        if (selectedModuleData) {
            const moduleInfo = JSON.parse(selectedModuleData);
            if (moduleInfo.autoSelectModule) {
                moduleToSelect = moduleInfo.autoSelectModule;
            }
        }
        
        // If no autoSelectModule, use filterType logic
        if (!moduleToSelect) {
            if (this.state.filterType === 'MASTER_PYQ_ONLY') {
                if (this.state.targetYear === '2027' && this.state.targetExam === 'JEE') {
                    moduleToSelect = 'MASTER_PYQ_JEE_27';
                } else if (this.state.targetYear === '2028' && this.state.targetExam === 'JEE') {
                    moduleToSelect = 'MASTER_PYQ_JEE_28';
                } else if (this.state.targetYear === '2027' && this.state.targetExam === 'NEET') {
                    moduleToSelect = 'MASTER_PYQ_NEET_27';
                } else if (this.state.targetYear === '2028' && this.state.targetExam === 'NEET') {
                    moduleToSelect = 'MASTER_PYQ_NEET_28';
                }
            } else if (this.state.filterType === 'AITS_JEE_ONLY') {
                if (this.state.targetExam === 'JEE' && this.state.targetYear === '2027') {
                    moduleToSelect = 'AITS_MAIN_ADVANCED'; // Default to MAIN+Advanced
                } else if (this.state.targetExam === 'NEET' && this.state.targetYear === '2027') {
                    moduleToSelect = 'AITS_NEET';
                }
            } else if (this.state.filterType === 'AITS_NEET_ONLY') {
                if (this.state.targetYear === '2027') {
                    moduleToSelect = 'AITS_NEET';
                }
            }
        }
        
        if (moduleToSelect) {
            this.setState({ selectedModule: moduleToSelect });
            this.setSignUpFormData("selectedModule", moduleToSelect);
        }
    }
    
    getBatchesByExam = (exam, presetYear = null) => {
        let me = this;
        const centerId = exam === 'NEET' ? 571 : 572;
        let reqData = {
            center_id: [centerId]
        };
        
        UserService.getBatchesByCenters(reqData, function (err, response) {
            if (!err && response && response.list) {
                const years = response.list.map(batch => ({
                    year: batch.name,
                    id: batch.id,
                    centerId: batch.center_id
                }));
                me.setState({ availableYears: years });
                
                if(presetYear) {
                    const selectedYearData = years.find(y => y.year === presetYear);
                    if(selectedYearData) {
                        me.setState({ 
                            targetYear: presetYear,
                            selectedBatchId: selectedYearData.id 
                        }, () => {
                            // Auto-select module after setting preset year
                            me.autoSelectModuleBasedOnFilter();
                        });
                    }
                }
            }
        });
    }
    
    handleModuleSelectionComplete = () => {
        if(this.state.selectedModule) {
            this.setState({ showModuleDialog: false });
            this.getCenters();
        }
    }
    
    getModuleDetails = () => {
        const moduleId = this.state.selectedModule;
        const moduleMap = {
            'MASTER_PYQ': { id: 24, name: 'Master PYQs', price: 299 },
            'MASTER_PYQ_2027': { id: 24, name: 'Master PYQs', price: 499 },
            'MASTER_PYQ_JEE_26': { id: 24, name: 'Master PYQs JEE', price: 1500 },
            'MASTER_PYQ_NEET_26': { id: 30, name: 'Master PYQs NEET', price: 1200 },
            'MASTER_PYQ_JEE_27': { id: 29, name: 'Master PYQs JEE', price: 1500 },
            'MASTER_PYQ_NEET_27': { id: 31, name: 'Master PYQs NEET', price: 1200 },
            'MASTER_PYQ_JEE_28': { id: 32, name: 'Master PYQs JEE', price: 2500 },
            'MASTER_PYQ_NEET_28': { id: 33, name: 'Master PYQs NEET', price: 2000 },
            'AITS_MAIN_ADVANCED': { id: 25, name: 'AITS JEE MAIN', price: 3999 },
            'AITS_NEET': { id: 26, name: 'AITS NEET', price: 2999 },
            'AITS_JEE_ADVANCED': { id: 27, name: 'AITS JEE Advanced', price: 1999 },
            'PRACTICE_PYQ_FREE': { id: null, name: 'Practice PYQs', price: 0 }
        };
        return moduleMap[moduleId] || { id: null, name: 'Unknown', price: 0 };
    }
    
    handleFreeModuleRedirect = (response) => {
        // Store user token and redirect for free modules
        localStorage.setItem('userToken', JSON.stringify(response.token));
        localStorage.setItem('user', JSON.stringify(response.user));
        sessionStorage.removeItem('signUpFormData');
        sessionStorage.removeItem('selectedModule');
        
        // Redirect to online platform
        setTimeout(() => {
            window.location.href = process.env.REACT_APP_REDIRECT_LOGIN_URL
              + 'auth/login?token=' + encodeURIComponent(response.token)
              + '&keepMeLoggedIn=false';
        }, 1000);
    }
    
    handlePaymentSuccess = () => {
        // Payment successful - user will be redirected by Payment component
        console.log('Payment completed successfully');
    }
    selectedCenter= (selectedCenter) => {
        this.setState({selectedCenter: selectedCenter});
        this.getBatches(selectedCenter);
        this.setSignUpFormData("selectedCenter",selectedCenter);
    }
    selectedBatch= (selectedBatch) => {
        this.setState({selectedBatch: selectedBatch});
        this.setSignUpFormData("selectedBatch",selectedBatch);

    }
    getCenters = () => {
        let me = this,
        reqData= {
            instituteId: constants.ONLINE_INSTITUTE_ID
        }
        UserService.getCenters(reqData, function (err, response) {
            if (!err && response) {
                let tmpArry = response.map(x => {
                    return { key: x.id, label: x.name, value: x.id }
                })
                me.setState({ centers: tmpArry});
            }
        });
    }
    getBatches = (selectedCenter) => {
        let me = this,
        reqData= {
            center_id: [selectedCenter.value]
        }
        UserService.getBatchesByCenters(reqData, function (err, response) {
            if (!err && response) {
                let tmpArry = response.list.map(x => {
                    return { key: x.id, label: x.name, value: x.id }
                })
                me.setState({ batches: tmpArry });
            }
        });
    }
    setImage=(value)=>{
        const imageRender =value==constants.ROLE_ID.PARENT?constants.SHOWIMAGE.PARENTSIGNUPIMAGE:constants.SHOWIMAGE.STUDENTSIGNUPIMAGE;
        this.props.renderImage(imageRender);
        const Component =value==constants.ROLE_ID.PARENT?constants.SHOWCOMPONENT.PARENTSIGNUP:constants.SHOWCOMPONENT.STUDENTSIGNUP;
        this.props.setSignUpType(Component);

    }
    getStudentByEmail = (email) => {
        let errors= {};
        let me = this,
        reqData= {
            email_id: email
        }
        UserService.getUserByEmail(reqData, function (err, response) {
            if (err) {
                errors["response"] = err.message;
                me.setState({ errors: errors });
                if (err.code==='ERR006') {
                    me.props.setIsNewStudent(true);
                    me.setState({studentName: ''});
                }

              }
            else {
                me.props.setIsNewStudent(false)

                me.setState({studentName: response.name});
            }
        });
    }
    isValidEmail = (email) => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(email)) {
            return true;
        }
        return false;
    }
    validateEmail = (email) => {
        let errors = {};
        let formIsValid = true;
        if (!this.isValidEmail(email)) {
            errors["studentEmail"] = "Email is not valid";
            this.setState({ errors: errors });
            formIsValid = false;
          }
        if(email){
            let lastAtPos = email.lastIndexOf('@');
            let lastDotPos = email.lastIndexOf('.');
    
            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') === -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2 && (email.length - lastDotPos) < 5 )) {
                formIsValid = false;
            }
        }
        return formIsValid
    }
    onChangeValue = (e) => {
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
         }
         if(e.target.name === "studentEmail" && this.state.role_id==constants.ROLE_ID.PARENT) {
             this.setState({
                 studentEmail: e.target.value,
                 typingTimeout: setTimeout( () => {
                     if(this.validateEmail(e.target.value)){
                     this.getStudentByEmail(e.target.value);
                     }
                    }, 1000)
                });
            }
            else {

                this.setState({ [e.target.name]: e.target.value });
            }
            if (e.target.name === 'role_id' && e.target.value !== this.state.role_id) {
                
                this.setState({
                    userName:"",
                    mobileNo:"",
                    email:"",
                    studentEmail:"",
                    studentName:"",
                    studentMobile:"",
                    selectedCenter:"",
                    selectedBatch:"",
                    errors: {}
                });
                this.props.setIsNewStudent(false);
                sessionStorage.removeItem('signUpFormData');
                const Component =this.state.role_id ? e.target.value==constants.ROLE_ID.PARENT?constants.SHOWCOMPONENT.PARENTSIGNUP:constants.SHOWCOMPONENT.STUDENTSIGNUP:'';
                this.setImage(e.target.value);
                this.props.setSignUpType(Component);
            }
            this.setSignUpFormData(e.target.name,e.target.value);
        } 
        handleKeyDown(e){
            if (e.key === 'e' ||e.key === '-' ||e.key === '+' ||e.key === '.' ) {
              e.preventDefault();
            }
          }  
          preventSpace(e){
            if (e.key === " ") {
                e.preventDefault();
              }
          }  
          onPaste(e) {
            const str = e.clipboardData.getData('Text');
            const newStr = str.replace(/[e+-.]/g, '');
            if (str !== newStr) {
              e.preventDefault()
             }
           } 
    handleValidation = () => {
        if(this.state.parentSignUp){
            // this.getStudentByEmail();
        }
        const name = this.state.userName ? this.state.userName : '';
        const email = this.state.email;
        const studentEmail = this.state.studentEmail;
        const studentName = this.state.studentName;
        const studentMobile = this.state.studentMobile;

        const mobileNo = this.state.mobileNo ? this.state.mobileNo : '';
        const studentSignUp = this.state.role_id == constants.ROLE_ID.STUDENT;
        const parentSignUp = this.state.role_id == constants.ROLE_ID.PARENT;
        const selectedCenter = this.state.selectedCenter ? this.state.selectedCenter.value : '';
        const selectedBatch = this.state.selectedBatch ? this.state.selectedBatch.value : '';
        let errors = {};
        let formIsValid = true;

        if (!name.replace(/\s+/g, '')) {
          formIsValid = false;
          errors["name"] = "Name cannot be empty";
        }
        else if(name.replace(/\s+/g, '').length<3){
            formIsValid=false;
            errors["name"] = "Please Enter a Valid Name";
          }
        if (!email) {
          formIsValid = false;
          errors["email"] = "Email cannot be empty";
        }
            if(email && !this.validateEmail(email)){
                    formIsValid = false;
                    errors["email"] = "Email is not valid";
            }
        if(parentSignUp && !name.replace(/\s+/g, '')){
            formIsValid=false;
            errors["name"] = "Name cannot be empty";
        }
        else if(parentSignUp && name.replace(/\s+/g, '').length<3){
            formIsValid=false;
            errors["name"] = "Please Enter a Valid Name";
        }
        if (parentSignUp && !studentEmail) {
            formIsValid = false;
            errors["studentEmail"] = "Email cannot be empty";
          }
        else if(parentSignUp && studentEmail && !this.validateEmail(studentEmail)){
            formIsValid = false;
            errors["studentEmail"] = "Email is not valid";
        }
        if(!mobileNo) {
            formIsValid = false;
            errors["mobileNo"] = "Mobile number cannot be empty";
        }
        if(mobileNo.length < 10 || mobileNo.length > 10 || !(mobileNo.match('[0-9]{10}'))){
            formIsValid = false;
            errors["mobileNo"] = "Please enter a valid 10 digit mobile number";
        }


        if (this.props.isNewStudent && !studentName.replace(/\s+/g, '')) {
            formIsValid = false;
            errors["studentName"] = "Please Enter Student Name";    
        }
        else if(this.props.isNewStudent && studentName.replace(/\s+/g, '').length<3){
            formIsValid = false;
            errors["studentName"] = "Please Enter a Valid Name";  
        }
        if (this.props.isNewStudent && !studentMobile) {
            formIsValid = false;
            errors["studentMobile"] = "Mobile number cannot be empty";
        }
        if (this.props.isNewStudent && studentMobile && (studentMobile.length<10 || studentMobile.length > 10)) {
            formIsValid = false;
            errors["studentMobile"] = "Please enter a valid 10 digit mobile number";
        }
       
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleSubmit = (event) => {
        event.preventDefault();
    }
    signUp = () => {
        if(this.handleValidation()){
            // if(this.state.studentSignUp){
                this.props.setUserEmail(this.state.email);
                this.props.setSignUpUser(this.state);

                this.props.setStudentsEmail(this.state.studentEmail)

            let me = this;
            me.setState({ isLoading: true });
            let errors= {};
            
            // Use dynamic batch_id and center_id from API response
            const batchId = me.state.selectedBatchId;
            const centerId = me.state.targetExam === 'NEET' ? 571 : 572;
            
            let reqData = {
                name: me.state.userName,
                email: me.state.email ,
                // canonical stored format — users.phone is unique at DB level
                phone: me.state.mobileNo ? '+91-' + me.state.mobileNo : me.state.mobileNo,
                role_id: 9,
                center_id: centerId,
                batch_id: batchId,
                selectedModule: me.state.selectedModule
            };
            if(me.state.role_id == constants.ROLE_ID.PARENT){
                reqData.details = {email: me.state.studentEmail, name: me.state.studentName}
            }
            if (me.props.isNewStudent) {
                reqData.details.register_student_user = true;
                reqData.details.phone = me.state.studentMobile ? '+91-' + me.state.studentMobile : me.state.studentMobile;
                reqData.details.role_id = constants.ROLE_ID.STUDENT;
                reqData.details.center_id = me.state.selectedCenter ? me.state.selectedCenter.value : [];
                reqData.details.batch_id = me.state.selectedBatch ? me.state.selectedBatch.value : [];
            }
            UserService.signUp(reqData, function (err, response) {
                if (err) {
                 me.setState({ isLoading: false });
                 me.state.role_id === constants.ROLE_ID.STUDENT ? errors["studentEmail"] = err.message : errors["parentEmail"] = err.message;
                  me.setState({ errors: errors });
                //   me.toast.error(err);
                if (err.code==='ERR0130') {
                    me.props.setSignUpUser(this.state);
                    toast.error(<NotificationMessage reqData={reqData}/>, {
                          autoClose: constants.TOAST_TIMEOUT_MEDIUM,
                          theme:'colored',
                          toastId:err.code
                          
                        });
                }
                }
                else if(!err && response){
                    me.setState({ isLoading: false, signupComplete: true });
                    // Store signup response for payment API
                    // Store in both sessionStorage and localStorage for redundancy
                    sessionStorage.setItem('signupResponse', JSON.stringify(response));
                    localStorage.setItem('signupResponse', JSON.stringify(response));
                    me.props.setIsSignup(true);
                    
                    // All users (free and paid) go through OTP verification first
                    me.props.setCurrentComponent(constants.SHOWCOMPONENT.ENTERCODE);
                    me.props.setSignUpType(me.state.role_id == constants.ROLE_ID.STUDENT ? constants.SHOWCOMPONENT.STUDENTSIGNUP : constants.SHOWCOMPONENT.PARENTSIGNUP);
                }
            });
        }
    }
  getFilteredModules = () => {
    console.log('Filtering modules with state:', this.state);
    const allModules = [
      { id: 'MASTER_PYQ_JEE_27', name: 'Master PYQs', price: '₹1500', description: 'Adaptive Mastery of PYQ questions', year: '2027', exam: 'JEE' },
      { id: 'MASTER_PYQ_JEE_28', name: 'Master PYQs', price: '₹2500', description: 'Adaptive Mastery of PYQ questions', year: '2028', exam: 'JEE' },
      { id: 'MASTER_PYQ_NEET_27', name: 'Master PYQs', price: '₹1200', description: 'Adaptive Mastery of PYQ questions', year: '2027', exam: 'NEET' },
      { id: 'MASTER_PYQ_NEET_28', name: 'Master PYQs', price: '₹2000', description: 'Adaptive Mastery of PYQ questions', year: '2028', exam: 'NEET' },
      { id: 'AITS_MAIN_ADVANCED', name: 'AITS JEE MAIN', price: '₹3999', description: 'Comprehensive Dual Prep Testing', year: '2027', exam: 'JEE' },
      { id: 'AITS_JEE_ADVANCED', name: 'AITS JEE Advanced', price: '₹1999', description: 'For the Final Stage Mastery', year: '2027', exam: 'JEE' },
      { id: 'AITS_NEET', name: 'AITS NEET', price: '₹2999', description: 'Dedicated to the Doctors of tomorrow', year: '2027', exam: 'NEET' },
      { id: 'PRACTICE_PYQ_FREE', name: 'Practice PYQs', price: 'Free', description: 'Free 5 Year Exam Access', year: 'both', exam: 'both' }
    ];

    
    // Show only free module for users coming from signup link
    if (this.state.filterType === 'FREE_SIGNUP_ONLY') {
      return [{ id: 'PRACTICE_PYQ_FREE', name: 'Practice PYQs', price: 'Free', description: 'Free 5 Year Exam Access', year: 'both', exam: 'both' }];
    }
    
    // Apply specific filtering based on Purchase Now button clicked
    if (this.state.filterType === 'MASTER_PYQ_ONLY') {
        console.log('Filtering for MASTER_PYQ_ONLY:', this.state.targetYear, this.state.targetExam);
      if (this.state.targetYear === '2027' && this.state.targetExam === 'JEE') {
        return [{ id: 'MASTER_PYQ_JEE_27', name: 'Master PYQs', price: '₹1500', description: 'Adaptive Mastery of PYQ questions', year: '2027', exam: 'JEE' }];
      } else if (this.state.targetYear === '2028' && this.state.targetExam === 'JEE') {
        return [{ id: 'MASTER_PYQ_JEE_28', name: 'Master PYQs', price: '₹2500', description: 'Adaptive Mastery of PYQ questions', year: '2028', exam: 'JEE' }];
      } else if (this.state.targetYear === '2028' && this.state.targetExam === 'NEET') {
        return [{ id: 'MASTER_PYQ_NEET_28', name: 'Master PYQs', price: '₹2000', description: 'Adaptive Mastery of PYQ questions', year: '2028', exam: 'NEET' }];
      } else if (this.state.targetYear === '2027' && this.state.targetExam === 'NEET') {
        return [{ id: 'MASTER_PYQ_NEET_27', name: 'Master PYQs', price: '₹1200', description: 'Adaptive Mastery of PYQ questions', year: '2027', exam: 'NEET' }];
      }
      return [];
    }

    if (this.state.filterType === 'AITS_JEE_ONLY') {
      if (this.state.targetExam === 'JEE' && this.state.targetYear === '2027') {
        return allModules.filter(module =>
          module.id === 'AITS_MAIN_ADVANCED' || module.id === 'AITS_JEE_ADVANCED'
        );
      } else if (this.state.targetExam === 'NEET' && this.state.targetYear === '2027') {
        return allModules.filter(module => module.id === 'AITS_NEET');
      }
    }

    if (this.state.filterType === 'AITS_NEET_ONLY' && this.state.targetYear === '2027') {
      return allModules.filter(module => module.id === 'AITS_NEET');
    }

    if( this.state.filterType === 'MASTER_AND_FREE_PYQ_ONLY') {
        if(this.state.targetYear === '2027' && this.state.targetExam === 'JEE'  ){
            return allModules.filter(module =>
                module.id === 'MASTER_PYQ_JEE_27' || module.id === 'PRACTICE_PYQ_FREE'
              );
        }
        else if(this.state.targetYear === '2028' && this.state.targetExam === 'JEE'  ){
            return allModules.filter(module =>
                module.id === 'MASTER_PYQ_JEE_28' || module.id === 'PRACTICE_PYQ_FREE'
              );
        }
        else if(this.state.targetYear === '2027' && this.state.targetExam === 'NEET'  ){
            return allModules.filter(module =>
                module.id === 'MASTER_PYQ_NEET_27' || module.id === 'PRACTICE_PYQ_FREE'
              );
        }
        else if(this.state.targetYear === '2028' && this.state.targetExam === 'NEET'  ){
            return allModules.filter(module =>
                module.id === 'MASTER_PYQ_NEET_28' || module.id === 'PRACTICE_PYQ_FREE'
              );
        }
    }
    
    // Default filtering by year and exam when no specific filter type
    if (this.state.targetYear && this.state.targetExam ) {
      return allModules.filter(module => 
        (module.year === this.state.targetYear || module.year === 'both') &&
        (module.exam === this.state.targetExam || module.exam === 'both')
      );
    }
    
    return allModules;
  }

  renderModuleSelection = () => {
    const filteredModules = this.getFilteredModules();
    const showYearSelection = true;
    const showExamSelection = true;
    const showModules = this.state.targetYear && this.state.targetExam; // Only show modules after exam and year selection
    
    return (
        <div className="form-min-block-1">
            {showExamSelection && (
                <Form.Group className="mb-4">
                    <Form.Label className="input-label">Pick a Stream</Form.Label>
                    <div className="d-flex gap-3 mt-2">
                        <div 
                            className={`card p-3 text-center ${this.state.targetExam === 'JEE' ? 'border-danger bg-light' : 'border-secondary'}`}
                            onClick={() => this.handleTargetExamSelect('JEE')}
                            style={{flex: 1, cursor: 'pointer', border: this.state.targetExam === 'JEE' ? '2px solid #dc3545' : '1px solid #6c757d'}}
                        >
                            <h5 className="mb-0">Engineering</h5>
                        </div>
                        <div 
                            className={`card p-3 text-center ${this.state.targetExam === 'NEET' ? 'border-danger bg-light' : 'border-secondary'}`}
                            onClick={() => this.handleTargetExamSelect('NEET')}
                            style={{flex: 1, cursor: 'pointer', border: this.state.targetExam === 'NEET' ? '2px solid #dc3545' : '1px solid #6c757d'}}
                        >
                            <h5 className="mb-0">Medical</h5>
                        </div>
                    </div>
                </Form.Group>
            )}
            {showYearSelection && this.state.targetExam && (
                <Form.Group className="mb-4">
                    <Form.Label className="input-label">Target Year</Form.Label>
                    <div className="d-flex gap-3 mt-2 flex-wrap">
                        {this.state.availableYears.map(yearData => (
                            <div 
                                key={yearData.year}
                                className={`card p-3 text-center ${this.state.targetYear === yearData.year ? 'border-danger bg-light' : 'border-secondary'}`}
                                onClick={() => this.handleTargetYearSelect(yearData.year)}
                                style={{flex: 1, cursor: 'pointer', border: this.state.targetYear === yearData.year ? '2px solid #dc3545' : '1px solid #6c757d', minWidth: '120px'}}
                            >
                                <h5 className="mb-0">{yearData.year}</h5>
                            </div>
                        ))}
                    </div>
                </Form.Group>
            )}
            
            {showModules && (
            <Form.Group className="mb-4">
                <Form.Label className="input-label">Available Modules</Form.Label>
                <div className="d-flex flex-column gap-3 mt-2">
                    {filteredModules.map(module => (
                        <div 
                            key={module.id}
                            className={`card p-3 ${this.state.selectedModule === module.id ? 'border-danger bg-light' : 'border-secondary'}`}
                            onClick={() => this.handleModuleSelect(module.id)}
                            style={{cursor: 'pointer', border: this.state.selectedModule === module.id ? '2px solid #dc3545' : '1px solid #6c757d'}}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 className="mb-1">{module.name}</h6>
                                    <small className="text-muted">{module.description}</small>
                                </div>
                                <div className="text-right">
                                    <strong>{module.price === 'Free' ? module.price : `${module.price} + taxes`}</strong>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Form.Group>
            )}
            
            <Form.Group className="mb-3">
                <Button 
                    buttonStyle={this.state.selectedModule && this.state.targetYear && this.state.targetExam ? "red-btn btn-full-size no-margin" : "red-btn btn-full-size no-margin loading-btn-disable"}
                    onClick={this.state.selectedModule && this.state.targetYear && this.state.targetExam ? this.handleModuleSelectionComplete : null}
                    disabled={!this.state.selectedModule || !this.state.targetYear || !this.state.targetExam}
                >
                    Next
                </Button>
            </Form.Group>
        </div>
    );
  }

  render() {
    if (this.state.showModuleDialog) {
        return (
            <div className="reset-pass">
                {this.renderModuleSelection()}
            </div>
        );
    }
    
    if (this.state.showPayment) {
        return (
            <Payment 
                selectedModule={this.state.selectedModule}
                onPaymentSuccess={this.handlePaymentSuccess}
            />
        );
    }
    
    return (
        <div className="reset-pass">
            <Form onSubmit={this.handleSubmit}>
                <div className="form-min-block-1 std-bold-radio">
                <div className="mb-3 inline-radio">
                    <Form.Check
                        inline
                        label="Student Signup"
                        name="role_id"
                        type="radio"
                        id="inline-radio"
                        value={constants.ROLE_ID.STUDENT}
                        checked={this.state.role_id == constants.ROLE_ID.STUDENT}
                        onChange={this.onChangeValue}
                    />
                    {/* <Form.Check
                        inline
                        label="Parent Signup"
                        name="role_id"
                        type="radio"
                        id="inline-radio"
                        value={constants.ROLE_ID.PARENT}
                        checked={this.state.role_id == constants.ROLE_ID.PARENT}
                        onChange={this.onChangeValue}
                    /> */}
                </div>
                    <Form.Group className="mb-3">
                        <Form.Label className="input-label">Name</Form.Label>
                        <Form.Control name="userName" value={this.state.userName} type="text" placeholder="Enter Name" onChange={this.onChangeValue} />
                        <div className="error-msg error-msg-10">{ this.state.errors['name']}</div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="input-label">Email ID</Form.Label>
                        <Form.Control ref={this[constants.SIGNUP_REFS.STUDENT_REF]} name="email" value={this.state.email} type="email" placeholder="Enter Email ID" onChange={this.onChangeValue} onKeyDown={this.preventSpace} />
                        <div className="error-msg error-msg-10">{this.state.errors['email']}</div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="input-label">Mobile No.</Form.Label>
                        <Form.Control name="mobileNo" pattern="[0-9]*" onPaste={this.onPaste} value={this.state.mobileNo} type="number" placeholder="Enter Mobile No." onChange={this.onChangeValue} onWheel={ event => event.target.blur() } onKeyDown={this.handleKeyDown}/>
                        <div className="error-msg error-msg-10">{this.state.errors['mobileNo']}</div>
                    </Form.Group>
                    {this.state.role_id == constants.ROLE_ID.PARENT && <Form.Group className="mb-3">
                        <Form.Label className="input-label">Student Email ID</Form.Label>
                        <Form.Control ref={this[constants.SIGNUP_REFS.PARENT_REF]} name="studentEmail" type="email" placeholder="Enter Email ID" onChange={this.onChangeValue} value={this.state.studentEmail} onKeyDown={this.preventSpace} />
                        <div className="error-msg error-msg-10">{this.state.errors['studentEmail']}</div>
                    </Form.Group>}
                    {this.props.isNewStudent && <div className="student-txt-email">
                        The Student email ID entered by you is not registered. Please provide the following information to register the above Email ID as a new student.
                    </div>}
                    {this.props.isNewStudent && <Form.Group className="mb-3">
                        <Form.Label className="input-label">Student Name</Form.Label>
                        <Form.Control name="studentName" value={this.state.studentName} type="text" placeholder="Enter Name" onChange={this.onChangeValue} />
                        <div className="error-msg error-msg-10">{this.state.errors['studentName']}</div>
                    </Form.Group>}
                    {this.props.isNewStudent && <Form.Group className="mb-3">
                        <Form.Label className="input-label">Student Mobile No.</Form.Label>
                        <Form.Control name="studentMobile" pattern="[0-9]*" onPaste={this.onPaste} value={this.state.studentMobile} type="number" placeholder="Enter Mobile No." onChange={this.onChangeValue} onWheel={ event => event.target.blur() } onKeyDown={this.handleKeyDown} />
                        <div className="error-msg error-msg-10 ">{this.state.errors['studentMobile']}</div>
                    </Form.Group>}

            </div>                  
                <Form.Group className="mb-3">
                    <Button buttonStyle={this.state.isLoading ? "red-btn btn-full-size no-margin loading-btn-disable" : "red-btn btn-full-size no-margin loading-button"} loading={this.state.isLoading} type="button" onClick={this.signUp}>
                   {this.state.isLoading && <Loading/>}
                    {!this.state.isLoading && `SIGN UP`}
                    </Button>
                </Form.Group>
            </Form>
            <div className="or-login-text">OR Signup with</div>
            <div className="social-signup">
                <SocialLoginSignUp 
                setIsSocialSignUp={(isSocialSignUp)=>this.props.setIsSocialSignUp(isSocialSignUp)}
                closeLoginModal={(closeModal) => this.props.closeLoginModal(closeModal)}
                />
            </div>
        </div>
    );
  }
}

const mapStateToProps = state => ({
    user: state.webSiteUser.user,
    type: state.webSiteUser.type,
    signUpUser: state.webSiteUser.signUpUser
  })
  const mapDispatchToProps = dispatch => ({
    setUser: user => dispatch(setUser(user)),
    setType: type => dispatch(setType(type)),
    setCurrentComponent: currentComponent => dispatch(setCurrentComponent(currentComponent)),
    setSignUpUser: signUpUser => dispatch(setSignUpUser(signUpUser))
  })
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withCookies(SignUp))